/**
 * Copy for the two confirmations, in one place so the three surfaces that
 * trigger them (the Reports row toolbar, the Reports detail panel, and
 * /users/user) cannot word the same action differently.
 *
 * Each confirmation says the same three things: what the member loses, what is
 * NOT affected, and whether the admin can undo it from where they are standing.
 * The second is the one that gets forgotten — an admin restricting a member
 * needs to know they are not writing off the debt.
 */

/**
 * Restricting only. There is no restore variant because restoring does not
 * confirm — it is the undo, and putting a dialog in front of the way out is how
 * a member stays locked out longer than anyone intended (KAN-579 §2).
 */
export const restrictCopy = (name) => {
    // The name is in the title on purpose: from the Reports table this is fired
    // from a row of many, and "Restrict access?" alone does not say whose.
    const who = name || 'this user';

    return {
        title: `Restrict access for ${who}?`,
        okText: 'Restrict access',
        danger: true,
        body: [
            'This user won\u2019t be able to sign in or request advances. Existing advances and repayment obligations are unaffected.',
            'You can undo this from this page.',
        ],
    };
};

/**
 * The SSO warning. Longer than a Popconfirm can carry, which is why this action
 * gets a modal on every surface: the admin is about to act inside a real
 * member's account, and anything they do there is a real transaction attributed
 * to that member.
 */
export const ssoCopy = (name) => ({
    // Same fallback as restrictCopy: the Reports table can fire this from a row
    // whose record has no name, and "enter undefined's account" is worse than
    // the generic phrasing.
    title: name ? `You're about to enter ${name}'s account` : "You're about to enter this user's account",
    okText: name ? `Enter as ${name}` : 'Enter account',
    danger: false,
    body: [
        "This is not a preview. You'll be inside the real app as this user, and anything you do here is real: advances are real money leaving the account, and transactions are recorded as if the user made them.",
        'Only continue if you have a specific reason to be in this account.',
    ],
});
